const auFormats = {
  number: {
    LOCALE_CURRENCY: {
      style: 'currency',
      currency: 'AUD',
    },
  },
  date: {
    LOCALE_DATE: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    },
  },
};

export { auFormats };
